const AWSconfig = {
  accessKeyId: 'AKIAYND3KM66MRTVELKX',
  secretAccessKey: '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',
  region: 'us-east-1',
  source: 'noreply@ilocalbox.com',
  bucket: 'rpx-dev-ext-images-qr'
};
export default AWSconfig;
//source: 'ayaz.belim@epistic.net',
